import styled from 'styled-components';
import { UIText } from '../../typography';

export const ItemCardBidCount = styled(UIText)`
  text-align: right;
  display: block;
  width: 100%;
`;
